// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5d6d89e7","534":"0cf5d7d8","538":"0f3528a0","614":"c4022a98","980":"0eb23258"}[chunkId] + ".chunk.js";
};